/* 
 * Export component file to be used on project
*/

import ModalLogsVirtualRoom from './ModalLogsVirtualRoom.js';
export default ModalLogsVirtualRoom;
